<template>
    <div class="box" id="info-area" v-if="extraAddState&&extraAddState!=='no'">
      <div class="iatitle">加印照片：</div>
      <div class="flexwrap iaflex" @click="addprint">
        {{grouplist.length===0?'选择':''}}颜色和尺寸
        <div class="iafr">
          {{grouplist.length>0?'继续加印':'去加印'}}
          <img src="@/assets/right.png" class="iarightimg" />
        </div>
      </div>
      <print-list-group @previewImg="previewImg" @groupCalaNum="groupCalaNum"></print-list-group>
    </div>
</template>

<script>
import printListGroup from "@/components/printListGroup";
import {mapMutations,mapState,mapActions} from "vuex"
export default {
    components:{
        printListGroup
    },
    name:'extraAdd',
    props:{
        singlePrice:{
            type:Number,
            default:0
        }
    },
    data(){
        return {
            printInfo:{}
        }
    },
    computed:{
        ...mapState(['grouplist','extraAddState','printextra','actiBol'])        
    },
    activated(){
      if(!this.actiBol){
        return;
      }
      console.log("store：：：",this.$store)
        // this.printInfo = this.$store.getters.getQueryInfo;
        // console.log("this.printInfo:::",this.printInfo)
        let {key} = this.printextra
        if(key){
            this.getAllowAddPrint()
        }
    },
    methods:{
        ...mapMutations(['SETQUERYINFOEXTRA']),
        ...mapActions(['getchannelM']),
        getAllowAddPrint(){
            return this.getchannelM()
        },
        addprint(){
            this.$router.push({
              name:'addPrint',
              params:{singlePrice:this.singlePrice}
            })
        },
        groupCalaNum(num,index){
            this.$emit('groupCalaNum',num,index)
        },
        previewImg(bol,url){
            this.$emit('previewImg',bol,url)
        }
    }
}
</script>

<style lang="scss" scoped>
.flexwrap{
    display: flex;
  }
#info-area {
      box-sizing: border-box;
      padding:.18rem .22rem .16rem .16rem;
      .iatitle{
        font-size: .14rem;
        color:#363636;
        font-weight: bold;
        margin-bottom:.16rem;
      }
      .iaflex{
        justify-content: space-between;
        align-items: center;
        font-size: .14rem;
        color:#363636;
        .iafr{
          flex-shrink: 0;
          font-size: .12rem;
          color:#4455E4;
          line-height: .15rem;
          .iarightimg{
            width:.09rem;
            height:.15rem;
            vertical-align: text-bottom;
          }
        }
      }
    }
</style>